export class ThemeColor {
  name: string;
  displayText: string;
  class: string;
  compactStyleName: string;
  materialStyleName: string;
  customStylesheetName?: string;
}

export const ThemeColors: ThemeColor[] = [
  {
    name: 'light-blue',
    displayText: 'Blue Light Background',
    class: 'cc-devex-theme-color cc-devex-light-blue',
    compactStyleName: 'generic.light.compact',
    materialStyleName: 'material.blue.light',
    customStylesheetName: 'cc-light-blue'
  },
  {
    name: 'dark-blue',
    displayText: 'Blue Dark Background',
    class: 'cc-devex-theme-color cc-devex-dark-blue',
    compactStyleName: 'generic.dark.compact',
    materialStyleName: 'material.blue.dark'
  },
  {
    name: 'light-orange',
    displayText: 'Orange Light Background',
    class: 'cc-devex-theme-color cc-devex-light-orange',
    compactStyleName: 'generic.carmine.compact',
    materialStyleName: 'material.orange.light',
    customStylesheetName: 'cc-light-orange'
  },
  {
    name: 'light-teal',
    displayText: 'Teal Light Background',
    class: 'cc-devex-theme-color cc-devex-light-teal',
    compactStyleName: 'generic.greenmist.compact',
    materialStyleName: 'material.teal.light'
  }
];

export const DefaultPaletteName: string = 'CiraNet';

export const DefaultPaletteMode: string = 'Blend';

export const CiraNetChartPalette: string[] = [
  '#121f38', // Navy (replaces Material blue)
  '#ebe7de', // Sandstone (replaces Material red)
  '#217655', // Forest Green (replaces Material green)
  '#f59e0b', // Amber (replaces Material yellow)
  '#4dd5ac', // Mint (replaces Material pink)
  '#217655', // Forest Green (replaces Material purple)
  '#ff8f73', // Tile Light
  '#d7e3fe', // Sky
  '#e5563a', // Tile Dark
  '#ebe7de' // Sandstone
];

export const ChartPaletteNames: string[] = [
  'CiraNet',
  'Material',
  'Soft Pastel',
  'Harmony Light',
  'Pastel',
  'Bright',
  'Soft',
  'Ocean',
  'Office',
  'Vintage',
  'Violet',
  'Carmine',
  'Dark Moon',
  'Soft Blue',
  'Dark Violet',
  'Green Mist'
];

/**
 * Resolves a palette name to its value for DevExtreme charts.
 * Returns the CiraNet custom color array for 'CiraNet', or the palette name string for built-in palettes.
 */
export function resolveChartPalette(paletteName: string): string | string[] {
  return paletteName === 'CiraNet' ? CiraNetChartPalette : paletteName;
}

export const ChartPaletteExtensionModes: string[] = [
  'Alternate',
  'Blend',
  'Extrapolate'
];

export const CalendarColors: string[] = [
  '#2a7ee4',
  '#727bd2',
  '#7b49d3',
  '#00af2c',
  '#32c9ed',
  '#56ca85',
  '#8ecd3c',
  '#cc5c53',
  '#ff9747',
  '#581845',
  '#900C3F',
  '#C70039',
  '#7533FF',
  '#3366FF'
];
